<template lang="">
    <div>
        <!-- el tipo es {{this.$route.params.tipo}}! -->
        <div v-if="!es_pdf && this.$route.params.tipo==1">
            <img id='imagen'  :class="fondo" :src="require(`@/assets/documentacion/${name}`)" alt="Planta">
            <!-- hornos manipulador -->
            <div v-if="this.$route.params.id==8">
                <zona tipo="iframe" @click="mostrarPDF('/pdf/centrifugacion/MOVIMIENTO AUTOMATICO TUBOS.pdf')"  titulo="MOVIMIENTO AUTOMATICO TUBOS" position="absolute" heigth="96%" width="18%" top="2%" left="2%" />

                <zona tipo="iframe" @click="clicked(21)" titulo="b1" position="absolute" heigth="10%" width="46%" top="3%" left="21%" />
                <zona tipo="iframe" @click="clicked(22)" titulo="b1" position="absolute" heigth="10%" width="46%" top="17%" left="21%" />
                <zona tipo="iframe" @click="clicked(23)" titulo="b1" position="absolute" heigth="10%" width="46%" top="31%" left="21%" />
                <zona tipo="iframe" @click="clicked(24)" titulo="b1" position="absolute" heigth="10%" width="46%" top="50%" left="21%" />
                <zona tipo="iframe" @click="clicked(25)" titulo="b1" position="absolute" heigth="10%" width="46%" top="60%" left="21%" />
                <zona tipo="iframe" @click="clicked(26)" titulo="b1" position="absolute" heigth="10%" width="46%" top="73%" left="21%" />
                <zona tipo="iframe" @click="clicked(27)" titulo="b1" position="absolute" heigth="10%" width="46%" top="85%" left="21%" />

                <zona tipo="iframe" @click="clicked(28)" titulo="b1" position="absolute" heigth="96%" width="30%" top="2%" left="70%" />
            </div>
            <!-- Barrenado -->
            <div v-if="this.$route.params.id==2">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/barrenado/GRANALLADORA.pdf')" titulo="Granalladora" position="absolute" heigth="5.25%" width="15%" top="58%" left="85%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/barrenado/MARCAJE TUBOS.pdf')" titulo="Marcaje tubos" position="absolute" heigth="4.25%" width="5%" top="63%" left="89%" /> 
                <!-- barrenadoras -->
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora7.pdf')" titulo="Barrenadora 7" position="absolute" heigth="5.5%" width="33%" top="30%" left="30.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora8.pdf')" titulo="Barrenadora 8" position="absolute" heigth="5.5%" width="33%" top="35%" left="30.5%" />   
                <!-- <zona tipo="iframe" @click="mostrarPDF('/T1.pdf')" titulo="Granalladora" position="absolute" heigth="5.5%" width="31.5%" top="43%" left="30.5%" />    -->
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora 6.pdf')" titulo="Barrenadora 6" position="absolute" heigth="5.5%" width="31.5%" top="43%" left="30.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora 5.pdf')" titulo="Barrenadora 5" position="absolute" heigth="5.5%" width="31.5%" top="48.5%" left="30.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora2.pdf')" titulo="Barrenadora 2" position="absolute" heigth="11%" width="33%" top="60%" left="30.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora3.pdf')" titulo="Granalladora" position="absolute" heigth="5.5%" width="32%" top="73.5%" left="30.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora4.pdf')" titulo="Granalladora" position="absolute" heigth="5.5%" width="32%" top="79%" left="30.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora9.pdf')" titulo="Granalladora" position="absolute" heigth="6%" width="32%" top="85%" left="30.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/Barrenadora10.pdf')" titulo="Granalladora" position="absolute" heigth="6%" width="32%" top="92%" left="30.5%" />
                
                <!-- centrifugadoras de viruta -->
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA VIRUTA Nº1.pdf')"  titulo="Granalladora" position="absolute" heigth="8%" width="8%" top="20%" left="32.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA VIRUTA Nº2.pdf')"  titulo="Granalladora" position="absolute" heigth="8%" width="8%" top="87.5%" left="21%" />   

                <!-- Tornos CNC -->
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CNC 1.pdf')" titulo="Granalladora" position="absolute" heigth="8%" width="20%" top="13%" left="75%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CNC 3.pdf')" titulo="Granalladora" position="absolute" heigth="10%" width="20%" top="68%" left="75%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CNC 2.pdf')" titulo="Granalladora" position="absolute" heigth="10%" width="20%" top="83%" left="75%" />   

                <!-- Tornos -->
                <zona tipo="iframe" @click="mostrarPDF('/TORNO COQUILLAS.pdf')" titulo="Torno de coquillas" position="absolute" heigth="9%" width="20%" top="17%" left="42%" />   
                <zona tipo="iframe" @click="mostrarPDF('/TORNO DE TAPAS.pdf')" titulo="Torno de tapas" position="absolute" heigth="4%" width="8%" top="25.5%" left="53%" />   
                
                
                <zona tipo="iframe" @click="mostrarPDF('/BANCO ENDEREZADO.pdf')" titulo="Banco enderezado" position="absolute" heigth="4%" width="19%" top="46.5%" left="76%" />   
                <zona tipo="iframe" @click="mostrarPDF('/CABINA LIQUIDOS.pdf')" titulo="Cabina de bruto" position="absolute" heigth="15%" width="12%" top="21%" left="85%" />   
                <zona tipo="iframe" @click="mostrarPDF('/LAVADORA ULTRASONIDOS.pdf')" titulo="Lavadora ultrasonido" position="absolute" heigth="27%" width="18%" top="70%" left="2%" />   

                
                
                
                <zona tipo="iframe" @click="mostrarPDF('/CABINA DE BOCAS.pdf')" titulo="Cabina de bocas" position="absolute" heigth="12%" width="15%" top="30%" left="2%" />   
            </div>
            <!-- TORNO CNC 1 -->
            <!-- <div v-if="this.$route.params.id==114">  
          
                <zona tipo="iframe" @click="mostrarPDF('/GRANALLADORA.pdf')" titulo="Granalladora" position="absolute" heigth="90%" width="90%" top="5%" left="5%" />   
            </div> -->
            <!-- Granalladora -->
            <div v-if="this.$route.params.id==12">  
                <zona tipo="iframe" @click="mostrarPDF('/GRANALLADORA.pdf')" titulo="Granalladora" position="absolute" heigth="90%" width="90%" top="5%" left="5%" />   
            </div>

            <!-- Sala hornos -->
             <div v-if="this.$route.params.id==28">  
                <!-- Bobinas-->
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 17.pdf')" titulo="Granalladora" position="absolute" heigth="8.5%" width="3.5%" top="1%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 16.pdf')" titulo="Granalladora" position="absolute" heigth="8.5%" width="3.5%" top="10%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 19.pdf')" titulo="Granalladora" position="absolute" heigth="7%" width="2.75%" top="19%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 18.pdf')" titulo="Granalladora" position="absolute" heigth="7%" width="2.75%" top="26%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 2.pdf')" titulo="Granalladora" position="absolute" heigth="7%" width="2.75%" top="33.5%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 9.pdf')" titulo="Granalladora" position="absolute" heigth="8%" width="2.75%" top="47%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 10.pdf')" titulo="Granalladora" position="absolute" heigth="8%" width="2.75%" top="55.5%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 11.pdf')" titulo="Granalladora" position="absolute" heigth="6%" width="2.5%" top="64%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 13.pdf')" titulo="Granalladora" position="absolute" heigth="6%" width="2.5%" top="71%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 20.pdf')" titulo="Granalladora" position="absolute" heigth="8.5%" width="3%" top="78%" left="43%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 21.pdf')" titulo="Granalladora" position="absolute" heigth="8.5%" width="3%" top="89.5%" left="43%" />   

                <!-- Hornos -->
                <zona tipo="iframe" @click="mostrarPDF('/HORNO 16-17.pdf')" titulo="Granalladora" position="absolute" heigth="8%" width="1.5%" top="4%" left="55%" />   
                <zona tipo="iframe" @click="mostrarPDF('/HORNO 18-19.pdf')" titulo="Granalladora" position="absolute" heigth="9%" width="2%" top="30%" left="52%" />   
                <zona tipo="iframe" @click="mostrarPDF('/HORNO 2.pdf')" titulo="Granalladora" position="absolute" heigth="8%" width="2%" top="38%" left="47.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/HORNO 9-10.pdf')" titulo="Granalladora" position="absolute" heigth="8.5%" width="2%" top="55%" left="47.75%" />   
                <zona tipo="iframe" @click="mostrarPDF('/HORNO 11-13.pdf')" titulo="Granalladora" position="absolute" heigth="8.5%" width="2%" top="72.5%" left="47.75%" />   
                <zona tipo="iframe" @click="mostrarPDF('/HORNO 20-21.pdf')" titulo="Granalladora" position="absolute" heigth="12%" width="2.25%" top="85%" left="49%" />   

             </div>

            <!-- Centrifugadora -->
            <!-- <div v-if="[21,22,23,24,25,26,27].includes(this.$route.params.id)"> -->
            <div v-if="this.$route.params.id==21">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/EXTRACTOR C4.pdf')" titulo="Granalladora" position="absolute" heigth="32%" width="7%" top="36%" left="1%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CARRO PINTAR C4.pdf')" titulo="Granalladora" position="absolute" heigth="65%" width="42%" top="5%" left="11%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA N2.pdf')" titulo="Granalladora" position="absolute" heigth="50%" width="46%" top="35%" left="53.25%" />   
            </div>
            <div v-if="this.$route.params.id==22">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/EXTRACTOR C3.pdf')" titulo="Granalladora" position="absolute" heigth="32%" width="7%" top="36%" left="1%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CARRO PINTAR C3.pdf')" titulo="Granalladora" position="absolute" heigth="65%" width="42%" top="5%" left="11%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA N2.pdf')" titulo="Granalladora" position="absolute" heigth="50%" width="46%" top="35%" left="53.25%" />   
            </div>
            <div v-if="this.$route.params.id==23">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/EXTRACTOR C8.pdf')" titulo="Granalladora" position="absolute" heigth="32%" width="7%" top="36%" left="1%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CARRO PINTAR C8.pdf')" titulo="Granalladora" position="absolute" heigth="65%" width="42%" top="5%" left="11%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA N2.pdf')" titulo="Granalladora" position="absolute" heigth="50%" width="46%" top="35%" left="53.25%" />   
            </div>
            <div v-if="this.$route.params.id==24">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/EXTRACTOR C2.pdf')" titulo="Granalladora" position="absolute" heigth="32%" width="7%" top="36%" left="1%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CARRO PINTAR C2.pdf')" titulo="Granalladora" position="absolute" heigth="65%" width="42%" top="5%" left="11%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA N2.pdf')" titulo="Granalladora" position="absolute" heigth="50%" width="46%" top="35%" left="53.25%" />   
            </div>
            <div v-if="this.$route.params.id==25">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/EXTRACTOR C5.pdf')" titulo="Granalladora" position="absolute" heigth="32%" width="7%" top="36%" left="1%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CARRO PINTAR C5.pdf')" titulo="Granalladora" position="absolute" heigth="65%" width="42%" top="5%" left="11%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA N2.pdf')" titulo="Granalladora" position="absolute" heigth="50%" width="46%" top="35%" left="53.25%" />   
            </div>
            <div v-if="this.$route.params.id==26">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/EXTRACTOR C6.pdf')" titulo="Granalladora" position="absolute" heigth="32%" width="7%" top="36%" left="1%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CARRO PINTAR C6.pdf')" titulo="Granalladora" position="absolute" heigth="65%" width="42%" top="5%" left="11%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA N2.pdf')" titulo="Granalladora" position="absolute" heigth="50%" width="46%" top="35%" left="53.25%" />   
            </div>
            <div v-if="this.$route.params.id==27">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/EXTRACTOR C9.pdf')" titulo="Granalladora" position="absolute" heigth="32%" width="7%" top="36%" left="1%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CARRO PINTAR C9.pdf')" titulo="Granalladora" position="absolute" heigth="65%" width="42%" top="5%" left="11%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA N2.pdf')" titulo="Granalladora" position="absolute" heigth="50%" width="46%" top="35%" left="53.25%" />   
            </div>

            <!-- Centrifugadoras verticales -->
            <div v-if="this.$route.params.id==200">  
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA VERTICAL GRANDE.pdf')" titulo="Centrifugadora vertical grande" position="absolute" heigth="17%" width="17%" top="8%" left="7%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA_HORIZONTAL_PEQUENA_1.pdf')" titulo="Centrifugadora horizontal pequeña 1" position="absolute" heigth="16%" width="25%" top="30%" left="21%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA_HORIZONTAL_PEQUENA_7.pdf')" titulo="Centrifugadora horizontal pequeña 7" position="absolute" heigth="16%" width="25%" top="66%" left="21%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA VERTICAL MEDIANO.pdf')" titulo="Centrifugadora vertical mediana" position="absolute" heigth="7%" width="8.75%" top="54%" left="53%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/CENTRIFUGADORA_VERTICAL_PEQUENO.pdf')" titulo="Centrifugadora vertical mediana" position="absolute" heigth="7%" width="8.75%" top="75%" left="53%" />   

                <!-- Bobinas -->
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 22.pdf')" titulo="BOBINA HORNO 22" position="absolute" heigth="14%" width="9%" top="17%" left="61.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 6.pdf')" titulo="BOBINA HORNO 6" position="absolute" heigth="14%" width="9%" top="34%" left="61.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 4.pdf')" titulo="BOBINA HORNO 4" position="absolute" heigth="17%" width="9%" top="49%" left="61.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 8.pdf')" titulo="BOBINA HORNO 8" position="absolute" heigth="17%" width="9%" top="70%" left="61.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/BOBINA HORNO 7.pdf')" titulo="BOBINA HORNO 7" position="absolute" heigth="11%" width="7%" top="51%" left="35%" />   

                <!-- Hornos -->
                <zona tipo="iframe" @click="mostrarPDF('/pdf/HORNO 22-6.pdf')" titulo="BOBINA HORNO 7" position="absolute" heigth="27%" width="4.75%" top="26%" left="86%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/HORNO 4-7-8.pdf')" titulo="BOBINA HORNO 7" position="absolute" heigth="18%" width="4.75%" top="60%" left="86%" />   

                <!-- <zona tipo="iframe" @click="mostrarPDF('/pdf/HORNO 4-7-8.pdf')" titulo="HORNO_4_7_8" position="absolute" heigth="40%" width="9%" top="48%" left="61.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/HORNO 22-6.pdf')" titulo="HORNO_4_7_8" position="absolute" heigth="31.5%" width="9%" top="16%" left="61.5%" />  -->



            </div> 

            <!-- Soldadura -->
            <div v-if="this.$route.params.id==201">  
                <zona tipo="iframe" @click="mostrarPDF('/CABINA FITTINGS.pdf')" titulo="Cabina fitting" position="absolute" heigth="5%" width="15%" top="0%" left="77%" />   
                <zona tipo="iframe" @click="mostrarPDF('/MAQUINA PLASMA 5.pdf')" titulo="Maquina plasma 5" position="absolute" heigth="7%" width="15%" top="8%" left="79%" />   
                <zona tipo="iframe" @click="mostrarPDF('/MAQUINA PLASMA 4.pdf')" titulo="Maquina plasma 4" position="absolute" heigth="7%" width="15%" top="15%" left="79%" />   
                <zona tipo="iframe" @click="mostrarPDF('/MAQUINA PLASMA 3.pdf')" titulo="Maquina plasma 3" position="absolute" heigth="7%" width="15%" top="22%" left="79%" />   
                <zona tipo="iframe" @click="mostrarPDF('/MAQUINA PLASMA 2.pdf')" titulo="Maquina plasma 2" position="absolute" heigth="7%" width="15%" top="29%" left="79%" />   
                <zona tipo="iframe" @click="mostrarPDF('/MAQUINA PLASMA 1.pdf')" titulo="Maquina plasma 1" position="absolute" heigth="7%" width="15%" top="36%" left="79%" />   
                
                <zona tipo="iframe" @click="mostrarPDF('/ENDEREZADO DE CANAS 1.pdf')" titulo="Enderezado cañas 1" position="absolute" heigth="7%" width="20%" top="40%" left="39%" />   
                <zona tipo="iframe" @click="mostrarPDF('/CABINA LAVAR CANAS.pdf')" titulo="Cabina lavar cañas" position="absolute" heigth="5%" width="27%" top="74.5%" left="70%" />   
                <zona tipo="iframe" @click="mostrarPDF('/ENDEREZADO DE CANAS 2.pdf')" titulo="Enderezado cañas 2" position="absolute" heigth="7%" width="20%" top="50.5%" left="39%" />   
                <zona tipo="iframe" @click="mostrarPDF('/MAQUINA PLASMA 8.pdf')" titulo="Maquina plasma 8" position="absolute" heigth="7%" width="20%" top="29%" left="40%" />   
                <zona tipo="iframe" @click="mostrarPDF('/MAQUINA PLASMA 9.pdf')" titulo="Maquina plasma 9" position="absolute" heigth="7%" width="20%" top="22%" left="40%" />   
                
                <zona tipo="iframe" @click="mostrarPDF('/ROBOT WELDOLET.pdf')" titulo="Robot weldolet" position="absolute" heigth="33%" width="11%" top="14%" left="7.25%" />   
                
                <zona tipo="iframe" @click="mostrarPDF('/pdf/soldadura/PRENSA HIROGARNE.pdf')" titulo="PRENSA HIROGARNE" position="absolute" heigth="5%" width="3%" top="63%" left="95%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/soldadura/TORCEDURA CANAS.pdf')" titulo="Torcedura cañas" position="absolute" heigth="5%" width="27%" top="79.25%" left="70%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/soldadura/TALADRO INTERIOR.pdf')" titulo="TALADRO INTERIOR" position="absolute" heigth="5%" width="3%" top="40%" left="22%" />   
            </div> 

            <!-- Compresores -->
            <div v-if="this.$route.params.id==300"> 
                <zona tipo="iframe" @click="mostrarPDF('/pdf/compresores/CABINA GASES LABORATORIO.pdf')" titulo="Cabina gases laboratorio" position="absolute" heigth="10%" width="3%" top="23%" left="16%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/compresores/CABINA GASES I+D.pdf')" titulo="Cabina gases I + D" position="absolute" heigth="5%" width="6%" top="45%" left="31%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/compresores/COMPRESOR 1.pdf')" titulo="Compresor 1" position="absolute" heigth="16%" width="13%" top="23%" left="38%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/compresores/SECADORA DE AIRE.pdf')" titulo="Secadora de aire" position="absolute" heigth="11%" width="3%" top="23.5%" left="52.5%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/compresores/COMPRESOR 4.pdf')" titulo="Compresor 4" position="absolute" heigth="21%" width="11%" top="18%" left="64%" />   
            </div> 

            <!-- Torres -->
            <div v-if="this.$route.params.id==310"> 
                <zona tipo="iframe" @click="mostrarPDF('/pdf/torres/TORRE REFRIGERACION H 4-7-8.pdf')" titulo="TORRE REFRIGERACION H 4-7-8" position="absolute" heigth="11.25%" width="4%" top="67%" left="91.75%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/torres/TORRE REFRIGERACION H 20-21.pdf')" titulo="TORRE REFRIGERACION H 20-21" position="absolute" heigth="11.25%" width="4%" top="53%" left="76.8%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/torres/TORRE REFRIGERACION H 11-13.pdf')" titulo="TORRE REFRIGERACION H 11-13" position="absolute" heigth="11.25%" width="4%" top="53%" left="70.9%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/torres/TORRE REFRIGERACION H 9-10-2.pdf')" titulo="TORRE REFRIGERACION H 9-10-2" position="absolute" heigth="11.25%" width="4%" top="62%" left="64.8%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/torres/TORRE REFRIGERACION H 18-19.pdf')" titulo="TORRE REFRIGERACION H 18-19" position="absolute" heigth="11.25%" width="4%" top="44%" left="65%" />   
                <zona tipo="iframe" @click="mostrarPDF('/pdf/torres/TORRE REFRIGERACION H 16-17.pdf')" titulo="TORRE REFRIGERACION H 16-17" position="absolute" heigth="11.25%" width="4%" top="14%" left="64.5%" />   
           
            </div> 



        </div>

        <!-- <div v-if="this.$route.params.tipo==2">
            ESTO VA A SER PDF DIRECTO
        </div> -->
        <!-- PDF -->

        <div v-if="es_pdf">
            <button class="btn btn-primary btn-block" @click="exitPDF" color="success">Salir</button>
             <v-btn depressed @click="before">
            <
            </v-btn>
            <input type="number" class="text-center" :max="pageCount" v-model.number="currentPage"/> / {{pageCount}}
            <v-btn depressed @click="next">
            >
            </v-btn>
           <pdf :src="src"
           @num-pages="pageCount = $event"
			@page-loaded="pdfCargado($event)"
            :page="currentPage"
            
           ></pdf>
        
            <v-btn depressed @click="before">
            <
            </v-btn>
            <input type="number" class="text-center" :max="pageCount" v-model.number="currentPage"/>/ {{pageCount}}
            <v-btn depressed @click="next">
            >
            </v-btn>
            <button class="btn btn-primary btn-block" @click="exitPDF" color="success">Salir</button>
        </div>




    </div>
</template>
<script>
import Zona from '../../components/Zona.vue'
import pdf from 'vue-pdf'
export default {
    components: {
        Zona,pdf
    },
   
    data() {
        return {
            montado: false,
            src:'',
            currentPage: 1,
			pageCount: 0,
            es_pdf:false
        }
    },
    computed:{
        params() {
            return this.$route.params;
        },
        fondo(){
            return (this.$route.params.id!=28)? 'fondo':'sala'
        },
        name(){
            let resultado=''
            switch (this.$route.params.id) {
                case 2://ir a barrenado Sala
                case '2'://ir a barrenado Sala
                    resultado="BARRENADO/BARRENADO_SALA.jpg"
                    break;
                case '8'://Centrifugación
                case 8://Centrifugación
                    //resultado="BARRENADO/BARRENADO_SALA.jpg"
                    resultado="CENTRIFUGACION/CENTRIFUGADORAS_HORIZONTALES/CENTRIF_HORNOS_MANIPULADOR.jpg"
                    break;
                case '9'://Centrifugación
                case 9://Centrifugación
                    resultado="CENTRIFUGACION/HORNOS_HORIZONTALES/SALA_HORNOS.jpg"
                    break;
                case '10'://Centrifugación
                case 10://Centrifugación
                    resultado="CENTRIFUGACION/CENTRIFUGADORAS_HORIZONTALES/CENTRIF_HORNOS_MANIPULADOR.jpg"
                    break;
                case '11'://Centrifugación
                case 11://Centrifugación
                    resultado="CENTRIFUGACION/CENTRIFUGADORAS_HORIZONTALES/CENTRIF_HORNOS_MANIPULADOR.jpg"
                    break;
                case '12'://Centrifugación
                case 12://Centrifugación
                    resultado="BARRENADO/GRANALLADORA/GRANALLADORA.jpg"
                    break;
                case 110:
                case 111:
                case 18:
                case 19:
                case 17:
                case 16:
                case 15:
                case 14:
                case 13:
                    //   resultado="BARRENADO/GRANALLADORA/GRANALLADORA.jpg"
                        resultado="BARRENADO/barrenadora.jpg"
                    break;

                case 28://Centrifugación
                    resultado="CENTRIFUGACION/HORNOS_HORIZONTALES/SALA_HORNOS.jpg"
                    break;
                case 21:
                case 22:
                case 23:
                case 24: 
                case 25:
                case 26:
                case 27:        
                    resultado="CENTRIFUGACION/CENTRIFUGADORAS_HORIZONTALES/CENTRIF.jpg"
                    break;
                case 114:
                    resultado="BARRENADO/2_cnc_1.jpg"
                    break;
                case 115:
                    resultado="BARRENADO/2_CNC_2_y_3.jpg"
                    break;
                case 116:
                    resultado="BARRENADO/2_CNC_2_y_3.jpg"
                    break;
                case 200:
                    resultado="CENTRIFUGACION/CENTREIFUGADORAS_VERTICALES/CENTRIFUGADORAS_VERTICALES_SALA.jpg"
                    break; 
                case 201:
                    resultado="soldadura.png"
                    break;
                case 300:
                    // resultado="COMPRESORES/sala_compresores.png"
                    resultado="COMPRESORES/SALA.jpg"
                    break;
                case 310:
                    // resultado="COMPRESORES/sala_compresores.png"
                    resultado="TORRES.png"
                    break;
                default:
                    console.log("no es ninguno")
                    break;

            }
            return resultado
        },
    },
    getRuta(key){
        switch (key) {
            case value:
                
                break;
        
            default:

                break;
        }
    },
    mounted() {
        console.log("MONTADO!!!!!!!!!!!!!!!!!!")
        console.log(this.$route.params.tipo)
        if(this.$route.params.tipo==2){
            console.log(this.$route.params);
            this.mostrarPDF(this.$route.params.ruta)
        }
       
    },
    methods: {
        clicked(p) {
            console.log(p);
            this.$router.push({
                name: 'DocumentacionZona',
                params: {
                    'id': p,
                    'tipo':1
                }
            })
        },
        mostrarPDF(ruta){
            this.src = pdf.createLoadingTask(ruta);
            this.es_pdf=true
        },
        exitPDF(){
            if(this.$route.params.tipo==2){
                 this.$router.push({
                    name: 'Documentacion',
                    // params: {
                    //     'id': p,
                    //     'tipo':1
                    // }
                })
            }
            this.es_pdf=false;
        },
        pdfCargado(ev){
            this.currentPage = ev
            console.log("Cargado!")
        },
        next(){
            if(this.currentPage<this.pageCount)this.currentPage++;
        },
        before(){
            if(this.currentPage>1)this.currentPage--;
        },
    },
   
}
</script>
<style scoped>
    .fondo{
         position: absolute;
    height: 100%;
    width: 100%;
    /*width: 100%;*/
    /*object-fit: cover;*/
    top: 0%;
    left: 0px;
    } .sala{
        position: absolute;
        height: 100%;
    
        top: 0%;
        left: 42%;
    }
</style>